<template>
  <div class="enterprise-information">
    <div class="name">
      <p class="title">
        公司名称
      </p>
      <van-field v-model="merchant_name" placeholder="请输入企业名称/或个体工商" />
    </div>
    <div class="name">
      <p class="title">
        经营地址
      </p>
      <van-field v-model="address" placeholder="请输入经营地址" />
    </div>
    <div class="name">
      <p class="title">
        联系人
      </p>
      <van-field v-model="name" placeholder="请输入联系方式" />
    </div>
    <div class="name">
      <p class="title">
        联系方式
      </p>
      <van-field v-model="phone" type="tel" placeholder="请输入联系电话" />
    </div>
    <div class="name">
      <p class="title">
        统一社会信用代码
      </p>
      <van-field v-model="name" placeholder="请输入营业执照证件号" />
    </div>
    <div class="post-photo">
      <p class="title">
        注意：请上传营业执照
      </p>'
      <div>

      </div>
    </div>
    <!-- 城市 -->
    <!-- <div class="address" @click="showAddress = true">
      <p class="title">请选择城市区域</p>
      <p class="address-content">
        {{aaa}}
      </p>
    </div> -->
    <!-- 下一步按钮 -->
    <div class="next-btn" @click="$router.push('/business-contract')">

    </div>
    <contactWay></contactWay>
  </div>
</template>

<script>

import applyPartner from '../../components/partner/apply-partner'
import contactWay from '../../components/partner/contact-way'
// import addressList from '../../../public/addressList/area.js'
import enterpriseInformation from '../../components/merchant/enterprise-information'

import Vue from 'vue';
import { Field } from 'vant';

Vue.use(Field);

export default {
  data(){
    return{
      name: '',
      phone : '',
      idcard : '',
      // addressList : addressList,
      // showAddress : false,
      aaa: '',
      active: 1,
      address: '',
      merchant_name: ''
    }
  },
  components:{
    contactWay
  },
  methods:{

  }
}
</script>

<style lang="less" scoped>
  .partner-information{
    width: 7.1rem;
    height: 14.11rem;
    background: #ffffff;
    margin: 0 auto;
    margin-top: .1rem;
    border-radius: .1rem;
    .name{
      overflow: hidden;
      .title{
        font-size: 0.26rem;
        font-family: PingFang SC;
        font-weight: 600;
        color: #000000;
        line-height: .26rem;
        margin-top: .39rem;
        margin-left: .4rem;
      }
    
    }
    // 位置
    // .address{
    //   display: flex;
    //   align-items: center;
    //   margin-top: .5rem;
    //   .title{
    //     font-size: 0.26rem;
    //     font-family: PingFang SC;
    //     font-weight: 500;
    //     color: #FF491F;
    //     margin-left: .3rem;
    //   }
    //   .address-content{
    //     font-size: 0.26rem;
    //     font-family: PingFang SC;
    //     font-weight: 500;
    //     color: #212121;
    //     margin-left: .65rem;
    //     font-weight: bold;
    //   }
    // }
    .post-photo{
      .title{
        font-size: 0.22rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FF491F;
        margin-left: .3rem;
        margin-top: .38rem;
      }
    }
    // 下一步按钮
    .next-btn{
      width: 2.42rem;
      height: .72rem;
      background-image: url('../../assets/images/partner-img/btn.png');
      background-size: 2.42rem .72rem;
      margin: 0 auto;
      margin-top: 1.06rem;
    }
    .tel{
      font-size: 0.2rem;
      font-family: PingFang SC;
      font-weight: 300;
      color: #A7A7A7;
      text-align: center;
      margin: .91rem 0 .4rem 0;
    }
  }
</style>